export const paymentConstant = {
  SET_PAYMENT_INT_REQUEST: " SET_PAYMENT_INT_REQUEST",
  SET_PAYMENT_INT_SUCCESS: "SET_PAYMENT_INT_SUCCESS",
  SET_PAYMENT_INT_FAILURE: "SET_PAYMENT_INT_FAILURE",
};
